import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import {
  baseFastApiMedicalTreatmentRoute,
  baseFastApiMatterRoute,
} from "@/lib/data/requests/matters/matter";
import { serializeMedicalTreatmentBillPayload } from "@/lib/data/requests/matters/medical-treatment-payloads";
import {
  type APIResponse,
  type MedicalTreatmentBill,
  type SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMedicalTreatmentBillV3 = (
  data: Pick<MedicalTreatmentBill, "matterId"> &
    Partial<Omit<MedicalTreatmentBill, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<APIResponse<MedicalTreatmentBill>>(
      "matters/v4/medical-treatments/bills",
      {
        ...serializeMedicalTreatmentBillPayload(data),
        connections: data.connections ?? [],
      },
    )
    .then((res) => res.data);
};

export const updateMedicalTreatmentBillV1 = (
  data: Pick<MedicalTreatmentBill, "id" | "dateModified"> &
    Partial<MedicalTreatmentBill>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MedicalTreatmentBill>
    >(`${baseFastApiMedicalTreatmentRoute}/bills`, serializeMedicalTreatmentBillPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentBillV1 = (
  data: Pick<MedicalTreatmentBill, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatmentBill>
    >(`${baseFastApiMatterRoute}/medical-treatments/bills/${id}`)
    .then((res) => res.data);
};
